<template>
<div id="my_auto">
    <link href="/static/css/cabinet/style.css" rel="stylesheet" />
    <link href="/static/css/cabinet/datedropper.min.css" rel="stylesheet"/>
    <div class="container bottom prev">
        <div class="row">
            <div class="silca col-md-120">
                <router-link style="font-size: 16px;" class="previous" to="/cabinet/">ДАННЫЕ КЛИЕНТА</router-link> |
                <b>МОЙ АВТО</b>
            </div>
            <div class="col-md-120">
                <div class="thumbnail zero-padding clearfix ">
                    <div class="thumbnail_head">
                        <h3>Новая запись</h3>
                    </div>
                    <div>
                        <div class="col-md-60">
                            <div class="form-group clearfix">
                                <label for="distance" class="control-label">Пробег</label><br>
                                <input type="number" name="distance" id="distance" class="form-control" v-model="probeg">
                            </div>
                            <div class="form-group clearfix">
                                <label for="description" class="control-label">Что сделано</label><br>
                                <textarea name="description" id="description" cols="3" rows="10" class="form-control" style="margin-top: 0;    height: 100px;" v-model="description"></textarea>
                            </div></div>
                        <div class="col-md-60">
                            <div class="form-group clearfix">
                                <label for="price" class="control-label">Стоимость</label><br>
                                <input type="number" name="price" id="price" class="form-control" v-model="price">
                            </div>
                            <div class="form-group clearfix">
                                <label for="comment" class="control-label">Комментарий</label><br>
                                <textarea name="comment" id="comment" cols="3" rows="10" class="form-control" style="margin-top: 0;    height: 100px;" v-model="comment"></textarea>
                            </div></div>
                        <button class="btn btn-primary btn_auto_form" type="submit" @click="addToCar">Сохранить</button>
                    </div>
                </div>
            </div>
            <div class="col-md-120">
                <table  class="accia_table table_bonus">
                    <tr class="table_bonus_perv">
                        <th width='120'><b>Дата</b></th>
                        <th><b>Пробег</b></th>
                        <th><b>Что сделано</b></th>
                        <th><b>Стоимость</b></th>
                        <th><b>Комментарии</b></th>
                    </tr>

                    <tr v-for="item in history" :key="item.id">
                        <td>{{item.created_at | date('Y-m-d H:i')}}</td>
                        <td>{{item.distance}}</td>
                        <td>{{item.description}}</td>
                        <td >{{item.price}}</td>
                        <td >{{item.comment}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'my',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      history: [],
      probeg: null,
      description: null,
      price: null,
      comment: null
    }
  },
  mounted () {
    axios.get('https://crm.v-avtoservice.com/list/get-my-car?uid=' + this.user.uid).then(response => {
      this.history = response.data
    })
  },
  methods: {
    addToCar () {
      if (!this.probeg) alert('Укажите пробег')
      else if (!this.description) alert('Укажите что было сделано')
      else {
        var formData = new FormData()
        formData.append('distance', this.probeg)
        formData.append('description', this.description)
        formData.append('price', this.price)
        formData.append('comment', this.comment)
        axios.post('https://crm.v-avtoservice.com/list/save-my-car?uid=' + this.user.uid,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          alert(response.data.text)
          this.history = response.data.history
          this.probeg = null
          this.description = null
          this.price = null
          this.comment = null
        })
      }
    }
  }
}
</script>

<style scoped>
    .form-control {
        width: 100%;
    }
    .date_r .form-control {
        width: 84%;
    }
</style>



// WEBPACK FOOTER //
// src/components/cabinet/user/my.vue